var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickChk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99985 17.9997C4.03724 17.9997 0 13.9625 0 8.99985C0 4.03724 4.03724 0 8.99985 0C10.4606 0 11.9104 0.357875 13.1937 1.03446C13.6644 1.28336 13.8451 1.86638 13.5968 2.33784C13.3485 2.8093 12.7662 2.9898 12.2934 2.74094C11.2868 2.20944 10.1477 1.92903 8.99985 1.92903C5.10081 1.92889 1.92815 5.10067 1.92815 9C1.92815 12.8993 5.09993 16.071 8.99911 16.071C12.8982 16.071 16.0708 12.8992 16.0708 9C16.0708 8.5543 16.0295 8.10875 15.9476 7.67731C15.8483 7.15433 16.192 6.6493 16.715 6.54998C17.238 6.45008 17.743 6.79499 17.8418 7.31741C17.9463 7.86747 17.9991 8.43305 17.9991 8.99941C17.9998 13.9628 13.9619 18 8.99962 18L8.99985 17.9997Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06313 12.5554H8.06255C7.80717 12.5554 7.56142 12.4529 7.38018 12.2722L4.66703 9.55055C4.29102 9.17325 4.29231 8.56315 4.66891 8.18655C5.04621 7.81054 5.65631 7.81124 6.03291 8.18842L8.06442 10.2264L16.4123 1.88108C16.7889 1.50448 17.3997 1.50448 17.7763 1.88108C18.1524 2.25768 18.1524 2.86848 17.7763 3.24449L8.74554 12.2735C8.5643 12.4534 8.31856 12.5553 8.06317 12.5553L8.06313 12.5554Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickChk);
export default __webpack_public_path__ + "static/media/tickChk.5c96a43bef6b2f490d4eb1e7ad25e921.svg";
export { ForwardRef as ReactComponent };